import script from "./StudentAnalysisPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudentAnalysisPage.vue?vue&type=script&setup=true&lang=ts"

import "./StudentAnalysisPage.vue?vue&type=style&index=0&id=e7084bde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7084bde"]])

export default __exports__